<!-- Localized -->
<template>
    <div class="profile-info transition-all overflow-y-auto scroll-bar bg-card-bg flex flex-col gap-6"
        :class="{
            'w-0 px-0 py-4': isCollapsed,
            'py-4 horizontal-padding': !isCollapsed,
            'rounded-tr-xl rounded-br-xl' : !isCollapsedCheck,
        }">
        <!-- <profile-info-card @getCaseDetails="$emit('getCaseDetails', $event)" :isSystemIntegratedCheck="isSystemIntegratedCheck" :systemIntegratedCheckName="systemIntegratedCheckName" @getNeoCaseID="getNeoCaseID" v-if="entityType!='Case'"/> -->

        <div class="icons-section bg-gray-200 rounded-xl p-3">
            <icons-list :handleClearCallActiveLog="handleClearCallActiveLog" :icons="btns" :onSelect="handleShowModal" :activeIcon="activeIcon" :activity_count="activity_count">
                <template v-slot:item="{ item }">
                    <component :is="item.svg"></component>
                </template>
            </icons-list>
        </div>
        <div class="list-section overflow-y-auto scroll-bar pb-0.5" v-if="showCheckList">
            <ul class="static-list list-none bg-white p-0 mb-2">
                <li
                    class="lists lists__static flex justify-between items-center gap-6 max-h-10"
                    @click="$emit('isClicked', { key: 'overview', type: 'static' })"
                    :style="[
                        selectedCheck == 'overview'
                            ? {
                                  'background-color': '#cce3ff',
                                  'border-right': '4px solid #3b2cd4',
                              }
                            : {
                                  'background-color': '#f2f2f2',
                                  'border-right': '1px solid #a8a8a8',
                              },
                    ]"
                >
                    <OverviewIcon />

                    <span class="flex-1 py-1">{{ $t('components.overview') }}</span>
                </li>
            </ul>

            <!-- // actual check list from api  -->
            <ul class="list-none bg-white p-0 pb-6 overflow-y-auto"  v-if="translatedCheckList" v-allow:auth="'case.read_check_screen'">
                <li v-for="(list, idx) in translatedCheckList"
                :key="list.check_id + list.check_name"
                class="justify-between cursor-pointer items-center px-4 py-2.5 gap-6 max-h-20"
                :class="[
                    isTimelineLoading ? 'cursor-not-allowed' : 'cursor-pointer',
                    selectedCheck == list.check_id
                    ? 'border-primary-300  border-b bg-blue-100 border-r-4 hover:bg-blue-200  border '
                    : ' border hover:bg-base-200',
                    idx == translatedCheckList.length - 1 ? '' : 'border-b-0',
                    CaseCheckFormPreviewLoader ? 'pointer-events-none text-gray-500' : ''
                ]"
                @click="$emit('isClicked', {
                    key: list.check_id,
                    type: list.check_category,
                    subtype: list.check_subtype,
                    stage_id: list.stage_id,
                    title: list.check_name,
                    id: list.id,
                    status: list.status,
                    statuses: list.statuses?.map((stat) => ({
                        ...stat,
                        selected: stat.status_id === list.status.status_id,
                    })),
                    integration_source_id: list?.integration_source_id,
                    description: list?.description,
                    check_label: list?.check_label,
                    check_name: list?.check_name,
                })">
                    <!-- <span class="flex-3 w-6 relative" :class="{'opacity-50': CaseCheckFormPreviewLoader}">
                        <EmploymentIcon v-if="list.svgName === 'employment'" />
                        <EducationIcon v-if="list.svgName === 'education'" />
                        <DifferenceIcon v-if="list.svgName === 'difference'" />
                        <OthersIcon v-if="list.svgName === 'other'" />
                        <OthersIcon v-else />

                    </span> -->
                    <div class="flex justify-between cursor-pointer items-center">
                    <span class="flex-1 text-left text-sm truncate" style="max-width: 270px">
                        {{ list?.translations?.check_label ||  list?.translations?.check_name}}
                    </span>
                    <div class="relative" @click="handleSettings($event)" v-if="list.check_category === 'Integrated Check' && list.monitoring_allowed  && list.monitoring_license">
                            <span>
                                <font-awesome-icon icon="ellipsis-v" class="p-2 h-4 box-size-initial text-gray-400 focus:outline-none" v-if="!list.frequency || list.monitoring_status ==='disabled'" v-tippy :content="`Monitoring Settings`"> </font-awesome-icon>
                          
                            <a class="p-2 text-xs font-semibold text-brand mx-auto no-underline hover:underline" v-else-if="list.monitoring_status === 'enabled'" v-tippy :content="$t('components.searched_queries.frequency', {value: list.frequency})">{{list.frequency}} d </a>
                             </span>
                            <tippy class="relative" :onHidden="hideOptionsBgLayer" :onShow="showOptionsBgLayer"  arrow arrowType="round" interactive theme="light monitoring" trigger="click" maxWidth="500" size="large">
                                <options-widget
                                    :ref="`options-widget-${list.check_name}`"
                                    source="monitoring-check"
                                    :monitoring_data="{
                                        monitoring_status: list.monitoring_status === 'enabled',
                                        frequency: list.frequency,
                                    }"
                                    :tool="list.tool"
                                    @updateFrequency="updateFrequency(list, true)"
                                    @updateMonitoring="updateMonitoring"
                                >
                                </options-widget>
                            </tippy>
                            <div ref="optionsbgLayer" id="optionsbgLayer" @click="isOpen = false"></div>
                    </div>
                    </div>

                    <div class="flex items-center justify-between w-auto  gap-1">
                        <!-- :customStyles="{
                                maxWidth: '200px'
                            }"
                            :list-styles="{ maxWidth: '115px' }" -->
                        <DropdownMenu
                            :value="list.statuses"
                            value-attr="id"
                            :options="statusList"
                            trigger-class="card-short--check-status__dropdown px-2 py-0.5 rounded-md border"
                            :triggerStyles="{
                                'color': list?.status.status_colour,
                                'border': `1px solid ${list?.status.status_colour}`,
                            }"
                            :disabled="selectedCheck !== list.check_id"
                            :onSelect="(e) => $emit('statusChanged', e.option, list.id)"
                        >
                            <template v-slot:selected>
                                <div class="flex items-center w-auto min-w-max">
                                    <span class="rounded-full w-4 border border-solid border-gray-300 flex-shrink-0 h-4 mr-2"
                                        :title="list?.status?.status_name"
                                        :style="{
                                            'background-color': list?.status?.status_colour
                                        }">
                                    </span>
                                    <div class="text-left truncate text-xs font-bold flex-1" style="font-size:0.85rem;" :title="list?.status?.status_name">
                                        {{ list?.status.status_name }}
                                    </div>
                                </div>
                            </template>

                            <template v-slot:option="{ option }">
                                <span
                                    class="rounded-full w-4 border border-solid border-gray-300 flex-shrink-0 h-4"
                                    :style="{ 'background-color': option?.status_colour }"
                                ></span>
                                <div
                                    class="text-base font-bold w-auto min-w-max"
                                    style="font-size:0.85rem"
                                    :title="option?.status_name"
                                >
                                    {{ option?.status_name }}
                                </div>
                            </template>
                        </DropdownMenu>

                        <div class="flex items-center">
                            <div class="px-2 py-0.5 rounded-full border border-blue-500 flex text-center items-center cursor-default" 
                                style="min-width: 40px; background-color: white;" v-if="list.check_category === 'Integrated Check'"
                            >
                                <span class="text-xs font-medium text-color-blue-500 cursor-pointer" @click.stop="expandQueries(list)" >{{list.acknowledgedCount}}/{{ list.total_result }}</span>
                            </div>
                            <!-- <div class="px-2 py-0.5 rounded-full bg-brand flex text-center items-center cursor-default" 
                                v-if="list.eventCount && (list.check_name !== 'Search Engine' || getUserFeatures.includes('search_engine__monitoring'))" 
                                title="Monitoring Events">
                                <div class="font-semibold text-xs text-white mx-auto">{{ list.eventCount }}</div>
                            </div> -->

                            <i class="w-4 ml-1 mt-0.5 fa fa-angle-right"
                                :class="selectedCheck !== list.check_id ? 'text-gray-500': 'text-blue-600'"
                                @click.stop="expandQueries(list)"
                            ></i>
                        </div>
                    </div>

                    <!-- <span class="dots flex-1 gap-1 flex items-center justify-end" style="max-width: 25px">
                        <span
                        class="dots dots__dot1 transition-all  border border-solid border-gray-200"
                        v-for="ref in list.references"
                        :key="ref.case_reference_id"
                        :title="ref.status_name + '  ' + ref.status_description"
                        :style="{ backgroundColor: ref.status_color }"
                        ></span>
                    </span> -->
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
// import ProfileInfoCard from "../profile-info-card";
import EmploymentIcon from "@/assets/icons/svg/employment.svg";
import DifferenceIcon from "@/assets/icons/svg/difference.svg";
import EducationIcon from "@/assets/icons/svg/education.svg";
import OthersIcon from "@/assets/icons/svg/otherCheck.svg";
import OverviewIcon from "@/assets/icons/svg/overview.svg";
import Others from "@/assets/icons/svg/wOthers.svg";
import HistoryIcon from "@/assets/icons/svg/whistory.svg";
import FileManager from "@/assets/icons/svg/file-manager.svg";
import TaskIcon from "@/assets/icons/svg/wTask.svg";
import NotesIcon from "@/assets/icons/svg/wnotes.svg";
import TelIcon from "@/assets/icons/svg/wtel.svg";
import MailIcon from "@/assets/icons/svg/wEmail.svg";
import IconsList from "@/components/icons-list";
import DropdownMenu from '@shared/case-entities/components/DropdownMenu.vue'
const checklist = () => import("@/components/dashboard-components/checklist");
import { checklist as checklistData } from "@/components/dashboard-components/checklist/utils/checklist-data.js";
import { mapGetters , mapActions} from 'vuex';
import optionsWidget from "@shared/saas-components/options-widget";
import {TippyComponent} from "vue-tippy";
import axios from "@/axios";
import { caseEntityTypesMap } from "@shared/modules/localization/utils/caseEntityTranslation/constants";
import { translateEntity } from "@shared/modules/localization/utils/caseEntityTranslation";
import { TOOL_TO_CHECK_NAME_MAP } from "@shared/tools/utils/constants"

export default {
    name: "profile-info",
    components: {
        EducationIcon,
        "icons-list": IconsList,
        EmploymentIcon,
        "task-icon": TaskIcon,
        "tel-icon": TelIcon,
        "mail-icon": MailIcon,
        "notes-icon": NotesIcon,
        DifferenceIcon,
        OverviewIcon,
        "history-icon": HistoryIcon,
        others: Others,
        OthersIcon,
        DropdownMenu,
        // "profile-info-card": ProfileInfoCard,
        FileManager,
        "options-widget": optionsWidget,
        tippy: TippyComponent,
    },
    emits: ["isClicked"],
    props: {
        entityType: {
            type: String,
            default: "Case"
        },
        selectedCheck: {
            type: String,
            default: "",
        },
        handleClearCallActiveLog: Function,
        isCollapsed: {
            type: Boolean,
            default: false,
        },

        onSelectIconList: {
            type: Function,
            default: () => {},
        },
        activeIcon: {
            type: String,
            default: "",
        },
        checkLists: {
            type: Array,
            default: () => [],
        },
        entityId: {
            type: String,
            default: "",
        },
        activity_count: {
            type: Number,
            default: 0,
        },
        showCheckList: {
            type: Boolean,
            default: true
        },
        isSystemIntegratedCheck: {
            type: Boolean,
        },
        systemIntegratedCheckName: {
            type: Object,
            default: () => {},
        },
        isTimelineLoading: {
            type: Boolean,
            default: false,
        },
        CaseCheckFormPreviewLoader: {
            type: Boolean,
            default: false,
        },
        statusList: {
            type: Array,
            required: true,
        },
        isCollapsedCheck: {
            type: Boolean,
            default: false,
        },
        acknowledgedChecks: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            selectedConfig: {
                history: {
                    action: () => {
                        this.activeCheck = "";
                    },
                    component: checklist,
                    props: {
                        list: checklistData,
                    },
                },
            },
            lists: [],
            notes: {
                type: "",
                note: "",
            },
            activeMonitoring : [],
            // acknowledgedChecks : [],

        };
    },
   async mounted() {
    },
    methods: {
    ...mapActions({getDataMonitoring: "getDataMonitoring",getProductMonitoring: "getProductMonitoring"}),
        hanldeCloseModal(modal_name) {
            this.$modal.hide(modal_name);
        },

        handleShowModal(icon) {
            this.$modal.show(icon.key);
            this.onSelectIconList(icon.key);
        },
        method(modal_name) {
            if (modal_name == "add-note") {
                this.hanldeCloseModal(modal_name);
            }
            if (modal_name == "send-mail") {
                this.sendOptions = !this.sendOptions;
            }
            if (modal_name == "show-roles") {
                this.roleOptions = !this.roleOptions;
            }
        },
        expandQueries(list) {
            if (this.selectedCheck !== list.check_id) return;
            this.$emit('expandQueries');
        },
        hideOptionsBgLayer() {
            this.isOpen = false;
            const bgCopy = document.getElementById("options-bg-copy");
            bgCopy.remove();
            const filter = this.checkLists.filter(el => el.is_visible !== false);
            this.$nextTick(() => {
                filter.forEach(el => {
                    this.$refs[`options-widget-${el.check_name}`][0].resetOptionsWidget();
                });
            });
            return true;
        },
        showOptionsBgLayer() {
            this.isOpen = true;

            // Prevent duplicate backgrounds
            if (!document.getElementById("options-bg-copy")) {
                const originalLayer = document.getElementById("optionsbgLayer");
                if (originalLayer) {
                const optionsbgLayer = originalLayer.cloneNode();
                optionsbgLayer.classList = "bg-layer tw-fixed tw-inset-0 tw-bg-black tw-opacity-30 tw-z-50";
                optionsbgLayer.id = "options-bg-copy";
                optionsbgLayer.style.zIndex = "590";
                document.body.appendChild(optionsbgLayer);
                }
            }

            // Filter visible widgets
            const filter = this.checkLists.filter(el => el.is_visible !== false);

            // Initiate widgets on next DOM update
            this.$nextTick(() => {
                filter.forEach(el => {
                const widget = this.$refs[`options-widget-${el.check_name}`];
                if (widget) {
                    widget[0]?.initiateOptionsWidget();
                }
                });
            });
        },

        updateFrequency(data) {
                this.activeMonitoring.tool = data.tool;
                this.activeMonitoring.id = data._id
        },
        handleSettings(event) {
            event.stopPropagation();
        },
        updateMonitoring(data) {
            this.activeMonitoring = {
                ...this.activeMonitoring,
                ...{
                    status: data.monitoring_status,
                    frequency: data.frequency,
                },
            };
            this.updateActiveMonitoring();
        },
                
        updateActiveMonitoring() {
            if(this.monitoringTools[this.activeMonitoring.tool]) {
               this.updateDataMonitoring(this.activeMonitoring)
            }
            else
            this.createDataMonitoring(this.activeMonitoring);
        },
        
        // Function to set new monitoring
        async createDataMonitoring(monitoring) {
            let url = `/service/data-monitoring`;
            let freq = parseInt(monitoring.frequency, 10);
            let data = {
                frequency: freq || freq === 0 ? freq : 365,
                tool: monitoring.tool,
                monitoring_type: "case",
                product_name: this.getProduct?.name,
                product_id: this.getProduct?.key,
                status: monitoring.status,
                case_id: this.getNeoCaseId,
            };
            if(monitoring.tool === "search-engine-tool") 
            {
                data.count = 10,
                data.duration = 7
            }
            try {
                let response = await axios.post(url, data);
                if ((response?.status === 201 || response?.status === 200) && response?.data.status) {
                    this.$toast.success("Monitoring set successfully !");
                    await this.getDataMonitoring(); // Function to fetch monitoring data
                }
            } catch (error) {
                console.error(error);
            }
        },
        getIntegratedToolName(checkName) {
      const check = checkName?.toLowerCase()
      let toolName = ''

      for (const key in TOOL_TO_CHECK_NAME_MAP) {
        for (const checkName of TOOL_TO_CHECK_NAME_MAP[key]) {
          if (check?.includes(checkName)) {
            toolName = key;
            break;
          }
        }
      }

      return toolName;
    },
        
        // Function to update monitoring data
        async updateDataMonitoring(monitoring) {
            let url = `/service/data-monitoring`;
            let data = {
                id: monitoring.id,
                frequency: parseInt(monitoring.frequency, 10),
                monitoring_type: "case",
                status: monitoring.status,
            };
            if(monitoring.tool === "search-engine-tool") 
            {
                data.count = 10,
                data.duration = 7
            }
            try {
                let response = await axios.put(url, data);
                if (response?.status === 200 && response?.data.status) {
                    this.$toast.success("Monitoring updated successfully !");
                    await this.getDataMonitoring(); // Function to fetch monitoring data
                    // this.close();
                }
            } catch (error) {
                console.error(error);
            }
        },
        getTranslated(check) {
            return translateEntity(check, caseEntityTypesMap.CHECK);
        },
       
    },
    computed: {
        ...mapGetters(["getUserFeatures", "getProduct","productMonitoring", "getNeoCaseId", "monitoringTools"]),
        filteredCheckList() {
            if (!this.checkLists) return [];
                this.checkLists.map(el => {   
                    if(el.check_name.toLowerCase().includes("dnb"))   
                            el.tool = "dnb-tool";
                        else {                 
                 let toolName =  this.getIntegratedToolName(el.check_name)
        if(toolName){
            el.tool = toolName;
            if (toolName=='company-name' && (this.getUserFeatures.includes("corporate_record_bvd__monitoring") || this.getUserFeatures.includes("corporate_record_op__monitoring"))) 
            {
                el.monitoring_license = true
            }
           else if ( toolName === "dnb" && this.getUserFeatures.includes("corporate_record_db__monitoring")) {
                el.monitoring_license = true
            }
            else if( toolName == 'lexis-bridger-tool' && this.getUserFeatures.includes("adverse_media_pep_sanctions__monitoring")) {
                el.monitoring_license = true
            }
            else if (toolName == 'orbis-tool' &&  this.getUserFeatures.includes("corporate_record_orbis__monitoring")) {
                el.monitoring_license = true
            }
            else if (toolName== 'world-compliance-tool' && this.getUserFeatures.includes("wco_data_file_monitoring__adverse_pep_sanction")) {
               el.monitoring_license = true
            }
            else if(toolName === "search-engine-tool" && this.getUserFeatures.includes("search_engine__monitoring")) {
                el.monitoring_license = true
            }
                }
                 
            }
            
            })
            this.checkLists.map(el => {
                if(el.check_category === "Integrated Check") {
                    if (this.monitoringTools[el.tool]) {
                        el.frequency = this.monitoringTools[el.tool].frequency
                        el.monitoring_status = this.monitoringTools[el.tool].status
                        el._id = this.monitoringTools[el.tool]._id
                        el.count = this.monitoringTools[el.tool].count
                        el.duration = this.monitoringTools[el.tool].duration
                        
                    }
                }
            })
            this.acknowledgedChecks.forEach(el => {
                this.checkLists.forEach(check => {
                    if(check.check_name === el.check_name) {
                        check.acknowledgedCount = el.acknowledge_count;
                        check.total_result = el.final_result_count;
                    }
                })
            })
            return this.checkLists.filter((el) => el.is_visible !== false);
        },
        translatedCheckList() {
            return this.filteredCheckList.map((el) => ({
                ...el,
                monitoring_allowed: this.productMonitoring.some((tool) => tool.tool === el.tool && tool.status === 'enabled'),
                translations: this.getTranslated(el),
                status: translateEntity(el.status, caseEntityTypesMap.WORKFLOW),
                statuses: el.statuses.map(status => translateEntity(status, caseEntityTypesMap.WORKFLOW),)
            }));
        },
        btns() {
            return [
                {
                    svg: "mail-icon",
                    key: "mail",
                    title: this.$t('components.sc_journey.email'),
                    external: true
                },
                {
                    svg: "file-manager",
                    key: "file-manager",
                    title: this.$t('components.sc_journey.file_manager'),
                    external: false
                },
                {
                    svg: "tel-icon",
                    key: "tel",
                    title: this.$t('components.sc_journey.call'),
                    external: true
                },
                {
                    svg: "notes-icon",
                    key: "notes",
                    title: this.$t('components.sc_journey.note'),
                    external: false
                },
                {
                    svg: "task-icon",
                    key: "task",
                    title: this.$t('components.sc_journey.task'),
                    external: false
                },
                {
                    svg: "history-icon",
                    key: "history",
                    title: this.$t('components.sc_journey.history'),
                    count: true,
                    external: false
                },
                // {
                //   svg: "others",
                //   key: "others",
                // },
            ]
        },

        
    },
};
</script>

<style lang="scss" scoped>
.list-section {
    .static-list {
        :nth-child(1) {
            border-top: 1px solid #a8a8a8;
        }
    }
}
.gray-bg {
    background-color: #f2f2f2;
}

.profile-info {
     // border-top-right-radius: 0.75rem;
    // border-bottom-right-radius: 0.75rem;
    max-height: 100%;;
    max-width: 400px;

    &.horizontal-padding {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }
}
.lists {
    cursor: pointer;
    padding: 12px 0px 12px 20px;
    border: 1px solid #a8a8a8;
    text-align: left;
    vertical-align: middle;
    transition: background-color 300ms, border-right 100ms;
    // &:hover {
    //   background-color: #cce3ff;
    //   border-right: 4px solid #3b2cd4;
    // }
    &:not(:last-child) {
        border-bottom-width: 0;
    }
    &__static {
        background-color: #f2f2f2;
    }
}
.dots {
    width: 14px;
    height: 14px;
    border-radius: 100%;
    &__dot1 {
        background-color: #0dfb50;
    }
    &__dot2 {
        background-color: #ff0000;
    }
    &__dot3 {
        background-color: #a3a4a3;
    }
    &__dot4 {
        background-color: #5ed1f6;
    }
}
</style>
